var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    directives: [
      {
        name: "count",
        rawName: "v-count",
        value: {
          value: _vm.value,
          maxlength: _vm.maxlength,
          buttonDisabled: _vm.buttonDisabled,
        },
        expression: "{value, maxlength, buttonDisabled}",
      },
    ],
    attrs: {
      placeholder: _vm.$t("fu.search_bar.please_input"),
      "show-word-limit": "",
      disabled: _vm.disabled,
      value: _vm.value,
      type: "textarea",
      maxlength: _vm.maxlength,
    },
    on: { input: _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }